module.exports = __webpack_public_path__ + "img/bmss-wesson.041f199c.svg";